import React from 'react';
import { graphql } from 'gatsby';
import EngagemenetPanel from './EngagementPanel';
import { getSettingsClass } from '~/utils/helpers';

const EngagementPanelBlock: React.FC<{ block: EngagementPanelBlock }> = ({
  block,
}) => {
  const settingsClass = getSettingsClass(block.settings);
  return (
    <div
      className={`block__engagement_panel flex h-fit w-full justify-center ${settingsClass}`}
    >
      <EngagemenetPanel {...block} />
    </div>
  );
};

export default EngagementPanelBlock;

export const engagementPanelFragment = graphql`
  fragment EngagementPanelFragment on Block {
    engagement_panel_id
    settings {
      ...SettingsFragment
    }
    template_title {
      ...TextTemplateFragment
    }
    template_subtitle {
      ...TextTemplateFragment
    }
    cta_buttons {
      label
      url
      style
    }
    engagement_panel_image {
      ...ImageFieldFragment
    }
    template_note {
      ...TextTemplateFragment
    }
  }
`;
